import { Moon, Sun } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useTheme } from "./theme";

export default function ThemeSwitch() {
  const { theme, toggle } = useTheme();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  const seg = (active) =>
    `flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-[background-color,color,box-shadow] ${active ? "bg-[var(--pink)] text-[var(--on-accent)] shadow-[0_0_14px_var(--glow-pink)]" : "text-[var(--muted)] hover:text-[var(--ink)]"}`;
  return (
    <div data-testid="theme-switch" className="glass fixed bottom-5 left-5 z-30 rounded-full p-1 flex gap-1">
      <button data-testid="theme-dark-btn" onClick={() => theme !== "dark" && toggle()} className={seg(theme === "dark")}><Moon size={13} /> Dark</button>
      <button data-testid="theme-light-btn" onClick={() => theme !== "light" && toggle()} className={seg(theme === "light")}><Sun size={13} /> Light</button>
    </div>
  );
}
